module.exports = __webpack_public_path__ + "img/banner1.50c89a00.png";